package ai.flowstorm.common.ui

import ai.flowstorm.common.id.ObjectId
import ai.flowstorm.common.id.newId
import ai.flowstorm.core.video.VideoPreviewRequest
import ai.flowstorm.studio.App
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.model.Enum
import ai.flowstorm.studio.resources.space.VideoResource
import ai.flowstorm.studio.ui.form.VoiceId
import io.kvision.core.Resize
import io.kvision.form.select.Select
import io.kvision.form.text.TextArea
import io.kvision.form.text.textArea
import io.kvision.html.Button
import io.kvision.html.Div
import io.kvision.html.button
import io.kvision.html.div
import io.kvision.i18n.tr
import io.kvision.modal.Alert
import io.kvision.modal.Modal
import io.kvision.modal.ModalSize
import io.kvision.panel.simplePanel
import io.kvision.utils.perc
import io.kvision.utils.vh
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

class VideoPreview(
    withForm: Boolean = true,
    var getOptions: () -> VideoPreviewRequest = {
        VideoPreviewRequest("", newId(), "")
    },
    mainScope: CoroutineScope
) : CardPanel("Video preview") {

    val containerId = "flvVideoContainer"

    private val voice = VoiceId().apply {
        load(null)
    }
    private lateinit var previewDiv: Div
    private lateinit var previewButton: Button
    private var previewUrl: TextArea =
        TextArea(rows = 1) {
            disabled = true
            input.resize = Resize.NONE
        }
    private lateinit var previewText: TextArea

    val form = Form(VideoPreviewRequest.serializer()).apply {
        add(
            VideoPreviewRequest::voice_id,
            voice
        )
        add(
            VideoPreviewRequest::avatar,
            Select(options = UiHelpers.options(Enum.avatars), label = tr("Avatar"))
        )

    }

    init {
        simplePanel(className = "content-panel") {
            simplePanel(className = "content-form") {
                minWidth = 50.perc
                previewText = textArea()
                if (AppState.state.userRoles.any { it.spaceId == ObjectId(App.config.idMap.rootSpace) })
                    add(previewUrl)
                previewButton = button(tr("Try Video"), Icon.Run.def).apply {
                    onClick {
                        previewButton.disabled = true
                        val videoRequest = getOptions().apply {
                            this.text = previewText.value ?: ""
                        }
                        mainScope.launch {
                            try {
                                val videoResponse = VideoResource.render(videoRequest)
                                val modal = Modal(tr("Preview"), size = ModalSize.XLARGE) {
                                    div(
                                        content = """
                                                <video id="$containerId" style="height:100%;display:block;margin-left:auto;margin-right:auto" autoplay="false" controls>
                                                    <p>Your browser doesn't support HTML5 video. Here is a <a href="">link to the video</a> instead.</p>          
                                                </video>
                                            """.trimIndent(), rich = true
                                    ) {
                                        height = 80.vh
                                    }
                                }
                                modal.show()
                                // delay(2000)
                                loadVideo(videoResponse.url)
                            } catch (e: Throwable) {
                                console.error(e)
                                Alert.show(
                                    tr("Video Preview"),
                                    tr("Error occurred while generating video preview. Check your configuration.")
                                )
                            } finally {
                                previewButton.disabled = false
                            }
                        }
                    }
                }
            }
        }
    }

    @Suppress("UNUSED_VARIABLE")
    private fun loadVideo(url: String) {
        val container = document.getElementById(containerId)
        val videoUrl = url
        val flvjs = io.kvision.require("flv.js")
        js(
            "    if (flvjs.isSupported()) {\n" +
                    "        var flvPlayer = flvjs.createPlayer({\n" +
                    "            type: 'flv',\n" +
                    "            url: videoUrl\n" +
                    "        });\n" +
                    "        flvPlayer.attachMediaElement(container);\n" +
                    "        flvPlayer.load();\n" +
                    "        flvPlayer.play();\n" +
                    "    }"
        )
    }
}